module.exports = __webpack_public_path__ + "img/cloth_g1_item_16.f2837015.svg";